import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { PostFormsSignRequestType } from '../types';
import { postFormsSign } from '../requests/postFormsSing';

export const useExtFormsSign = (
  form: PostFormsSignRequestType['pathParams']['form'],
) => {
  const { i18n } = useTranslation();

  return useMutation({
    mutationFn: (body: PostFormsSignRequestType['body']) =>
      postFormsSign({
        pathParams: { form },
        body,
        headers: {
          'x-app-locale': i18n.language,
        },
      }),
  });
};
